import React from "react";
import styles from "./styles/ScadaSystems.module.css";
import { Reveal } from "../Home/common/Reveal";

import scadaImg from "../../../images/SCADA1.jpg";

const features = [
  "Control industrial processes locally or at remote locations",
  "Monitor, gather, and process real-time data",
  "Directly interact with devices such as sensors, valves, pumps, motors, etc. through HMI software",
  "Record events into a log file",
];

export default function ScadaSystems() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.heading}>SCADA Systems</h2>
          <div className={styles.accent} aria-hidden="true" />
          <p className={styles.intro}>
            Supervisory control and data acquisition (SCADA) is a system of software and hardware elements that allows industrial organizations to:
          </p>
        </div>
        <Reveal>
          <ul className={styles.featureList}>
            {features.map((feature) => (
              <li key={feature}>{feature}</li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={100}>
          <div className={styles.imageWrapper}>
            <img
              src={scadaImg}
              alt="SCADA MC Works supervisory control interface"
              className={styles.previewImage}
              loading="lazy"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
